import { FilterQuery } from "../../../@components/interfaces";
import { xhttp } from "../Fetchv2";
import { headhunting } from "../schemas/mg.schema";

type jobApp = { co_id: string; job_id: number; geo?: { lat: number; lon: number }; referrer: string };
interface RespJobApplication {
	id: number;
	created: boolean;
	uid: string;
	co_id: string;
	job_id: string;
	msg?: string;
}
export class Headhunting {
	async getProjects(
		pgid: string,
		body: {
			token?: string;
			skip?: number;
			limit?: number;
			filters?: FilterQuery<headhunting>;
		}
	) {
		type user = {
			_id: string;
			name: string;
			thumb_pp: string;
			username: string;
			is_verified: boolean;
		};
		let b = { ...body, f: JSON.stringify(body.filters) };
		let response = await xhttp<{ user: user; data: headhunting[] }>(`/pages/${pgid}/headhunting`, "SEARCH", b);
		return response;
	}

	async createProject(body: headhunting, token?: string) {
		let response = await xhttp<{ id: number }>(`/pages/${body.pgid}/headhunting`, "POST", { body: body, token });
		return response;
	}

	async deleteProject(body: { pgid: string; pid: number; token?: string }) {
		let response = await xhttp<{ deleted: boolean }>(`/pages/${body.pgid}/headhunting/${body.pid}`, "DELETE", body);
		return response;
	}
}
